var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[(_vm.errorComponent)?_c(_vm.errorComponent,{tag:"component"}):[(_vm.hasHeader)?_c('app-header'):_vm._e(),_c('router-view')],_c('app-snackbar'),_c('update-system-modal')],2)
}
var staticRenderFns = []

export { render, staticRenderFns }